import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-resumeLoadButton',
    template: `
    <button title="Delete Object(s) from Target" (click)="deleteCaseFromVault($event);"
            class="btn btn-outline btn-success btn-rounded btn-sm waves-effect waves-light"  [disabled]="params.node.data.isSetIdIsNegativeFloat || isdisable"
            style="padding: .3rem .8rem;margin-top:0rem">
      <i class="fas fa-play-circle"></i>
    </button>`,
    standalone: false
})
export class DeleteCaseButton implements ICellRendererAngularComp {

  params;
  label: string;
  isdisable:boolean=false;

  agInit(params): void {
    this.params = params;
    if(params.colDef.headerName== 'Delete Object(s) from Target'){
      this.isdisable=true;
      if(params.data.migrationType=="Data Migration"){
        this.isdisable=false;
      }
    }
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  deleteCaseFromVault($event) {
    if (this.params.deleteCaseFromVault instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        param:this.params
        // ...something
      }
      console.log(params)
      this.params.deleteCaseFromVault(params);

    }
  }
}
